import FloorCarpet from "./floor-carpet.svg";
import FloorHardwood from "./floor-hardwood.svg";
import FloorLaminate from "./floor-laminate.svg";
import FloorTile from "./floor-tile.svg";
import FloorVinyl from "./floor-vinyl.svg";

const icons = {
  "floor-carpet": FloorCarpet,
  "floor-hardwood": FloorHardwood,
  "floor-laminate": FloorLaminate,
  "floor-tile": FloorTile,
  "floor-vinyl": FloorVinyl,
};

export default icons;
